import React from 'react';
import { useSystemLegal } from '../hooks/use-system-legal.js';
import SystemLegalPageView from './system-legal-page-view.jsx';

function SystemLegalPageContainer() {
  const state = useSystemLegal();
  return <SystemLegalPageView {...state} />;
}

export default SystemLegalPageContainer;
